import { Request } from '../../components/request';
import React from 'react';

export const OpenRequestPage: React.FC = () => {
    return <Request />;
};
